import React from 'react';
// import { createDeliveryClient } from '@kontent-ai/delivery-sdk';
import Slider from 'react-slick';
import { Parallax, Background } from 'react-parallax';
import ComponentTitle from './ComponentTitle';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../CSS/Carousel.css';
import '../CSS/ReactSlickSlider.css';

const CarouselSetup: React.FC<{ element: any }> = ({ element }) => {
  // Add null safety checks
  const imageAssetValues = element.image_asset?.value || [];
  const imageAssets = Array.isArray(imageAssetValues)
    ? imageAssetValues.map((asset: any) => asset.url)
    : [];
  const imageDescriptions = Array.isArray(imageAssetValues)
    ? imageAssetValues.map((asset: any) => asset.description)
    : [];
  const hasMultipleImages = imageAssets.length > 1;

  const settings = {
    accessibility: true,
    arrows: hasMultipleImages,
    autoplay: false,
    dots: hasMultipleImages,
    infinite: hasMultipleImages,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    touchMove: true,
    centerMode: true,
    centerPadding: '0%',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          accessibility: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          touchMove: true,
          infinite: hasMultipleImages,
          dots: hasMultipleImages,
          centerMode: true,
          centerPadding: '0%',
          ...(hasMultipleImages && {
            appendDots: (dots: React.ReactNode) => (
              <div style={{ padding: '10px' }}>{dots}</div>
            ),
          }),
        },
      },
      {
        breakpoint: 600,
        settings: {
          accessibility: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          infinite: hasMultipleImages,
          dots: hasMultipleImages,
          centerMode: true,
          centerPadding: '0%',
          ...(hasMultipleImages && {
            appendDots: (dots: React.ReactNode) => (
              <div style={{ padding: '10px' }}>{dots}</div>
            ),
          }),
        },
      },
      {
        breakpoint: 480,
        settings: {
          accessibility: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          infinite: hasMultipleImages,
          dots: hasMultipleImages,
          centerMode: true,
          centerPadding: '0%',
          ...(hasMultipleImages && {
            appendDots: (dots: React.ReactNode) => (
              <div style={{ padding: '10px' }}>{dots}</div>
            ),
          }),
        },
      },
    ],
    ...(hasMultipleImages && {
      appendDots: (dots: React.ReactNode) => (
        <div
          style={{
            padding: '15px 5px',
            position: 'absolute',
            bottom: '-30px', // Position below the container instead of using top
            left: 0,
            right: 0,
            zIndex: 5,
            margin: 0,
            background: 'transparent',
            textAlign: 'center',
          }}
        >
          {dots}
        </div>
      ),
    }),
  };

  // Modify the carousel-wrapper and parallax configuration to better handle 750x422 images

  // Updated carousel configuration with better arrow positioning
  return (
    <div
      className="carousel-container"
      style={{
        position: 'relative',
        aspectRatio: '750/422',
        maxWidth: '750px',
        margin: '0 auto',
        marginBottom: '15px', // Increased space below to accommodate dots
      }}
    >
      {element.title && <ComponentTitle title={element.title.value} />}
      <div
        style={{
          aspectRatio: '750/422',
          position: 'relative',
          marginBottom: '15px', // Space for dots below image
        }}
      >
        {' '}
        <Slider
          {...settings}
          prevArrow={<div className="slick-prev"></div>}
          nextArrow={<div className="slick-next"></div>}
          dots={hasMultipleImages} // Explicitly enable dots
          dotsClass="slick-dots" // Use standard class
        >
          {imageAssets.map((imageUrl: string, idx: number) => (
            <Parallax
              key={idx}
              strength={300}
              bgImageStyle={{
                objectFit: 'contain',
                objectPosition: 'center',
                width: '100%',
                height: '100%',
              }}
            >
              <div className="carousel-wrapper">
                <div
                  className="carousel-image"
                  style={{
                    aspectRatio: '750/422',
                    height: 'auto',
                    maxHeight: '60vh',
                    margin: '0 auto',
                  }}
                >
                  <Background className="custom-bg">
                    <img
                      src={imageUrl}
                      alt={imageDescriptions[idx] || 'Image'}
                      style={{ maxWidth: '100%', height: 'auto' }}
                    />
                  </Background>
                </div>
              </div>
            </Parallax>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default CarouselSetup;
